export function getAuthHeader() {
    let user = JSON.parse(localStorage.getItem('__data'));

    if (user && user.token) {
        return {
            'Authorization': `Bearer ${user.token}`,
            'Content-Type': 'application/json'
        };
    } else {
        return {
            'Content-Type': 'application/json'
        };
    }
}

